/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Org_Contract_Approve_Overage_OnInputs */



/**
* | output |
* | --- |
* | "Pay-per-use after the budget: on — usage past the budget is metered and must be charged separately." |
*
* @param {Partner_Org_Contract_Approve_Overage_OnInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_org_contract_approve_overage_on = /** @type {((inputs?: Partner_Org_Contract_Approve_Overage_OnInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Org_Contract_Approve_Overage_OnInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Nutzungsbasierte Abrechnung nach dem Budget: an — Nutzung über das Budget hinaus wird gemessen und muss separat abgerechnet werden.")
	return /** @type {LocalizedString} */ ("Pay-per-use after the budget: on — usage past the budget is metered and must be charged separately.")
});